<template>
  <div class="ph-16 pb-24">
    <PrakerjaDetailExpandableSection v-if="categoryDescription" title="" :content="content" :height="400" class="qa-test-category-about" />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import PrakerjaDetailExpandableSection from '../PrakerjaDetailPage/PrakerjaDetailExpandableSection.vue';

export default {
  name: 'PrakerjaCategoryAbout',
  components: {
    PrakerjaDetailExpandableSection,
  },
  computed: {
    ...mapGetters('categories', ['getCategoriesConfig']),
    categoryId() {
      return this.$route.params.id;
    },
    categoryDetail() {
      return this.getCategoriesConfig.find((category) => category.id === Number(this.categoryId));
    },
    categoryDescription() {
      return this.categoryDetail?.description;
    },
    categoryListAnchor() {
      const basePath = `https://www.bukalapak.com${process.env.BASE_PATH}/kategori`;
      const htmlContent = this.getCategoriesConfig
        .filter((category) => category.id !== Number(this.categoryId))
        .map((category) => {
          return `<a style="color: #d71149" href="${basePath}/${category.id}?source=category-about">${category.name}</a>`;
        });
      return htmlContent.join(', ');
    },
    content() {
      return `${this.categoryDescription}
        <p class="mb-16 bl-text bl-text--caption-12">
          Kategori lainnya: ${this.categoryListAnchor}
        </p>`;
    },
  },
};
</script>

<style>
.prakerja-merchant-about__text {
  margin-bottom: 16px;
}
</style>
